module.exports = __webpack_public_path__ + "static/media/Axxela.6684e15b.png";